/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} QualityInputs */

const en_quality = /** @type {(inputs: QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quality`)
};

const es_quality = /** @type {(inputs: QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calidad`)
};

const fr_quality = /** @type {(inputs: QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualité`)
};

const de_quality = /** @type {(inputs: QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualität`)
};

const ja_quality = /** @type {(inputs: QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画質`)
};

const zh_quality = /** @type {(inputs: QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画质`)
};

const ar_quality = /** @type {(inputs: QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الجودة`)
};

const id_quality = /** @type {(inputs: QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kualitas`)
};

const it_quality = /** @type {(inputs: QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualità`)
};

const ru_quality = /** @type {(inputs: QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Качество`)
};

const pt_quality = /** @type {(inputs: QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualidade`)
};

const ko_quality = /** @type {(inputs: QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`화질`)
};

/**
* | output |
* | --- |
* | "Quality" |
*
* @param {QualityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const quality = /** @type {((inputs?: QualityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<QualityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quality(inputs)
	if (locale === "es") return es_quality(inputs)
	if (locale === "fr") return fr_quality(inputs)
	if (locale === "de") return de_quality(inputs)
	if (locale === "ja") return ja_quality(inputs)
	if (locale === "zh") return zh_quality(inputs)
	if (locale === "ar") return ar_quality(inputs)
	if (locale === "id") return id_quality(inputs)
	if (locale === "it") return it_quality(inputs)
	if (locale === "ru") return ru_quality(inputs)
	if (locale === "pt") return pt_quality(inputs)
	return ko_quality(inputs)
});